class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      // this.open(); Replace with the openCartDrawer function call
      // Open the cart drawer popout. See cart-drawer.js for implementation.
      if (typeof openCartDrawer === 'function') {
       openCartDrawer({ type: 'auto', source: this.getCartDrawerOpenSource() });
      }
  }

  getCartDrawerOpenSource() {
    const activeElement = this.activeElement || document.activeElement;
    if (!activeElement) return 'unknown';

    if (
      activeElement.closest('.quick-add') ||
      activeElement.closest('quick-add-modal') ||
      activeElement.closest('[data-product-card]')
    ) {
      return 'plp';
    }

    if (
      activeElement.closest('.product-form-sticky') ||
      activeElement.closest('.sticky-add-to-cart') ||
      activeElement.closest('[data-sticky-add-to-cart]')
    ) {
      return 'sticky_pdp';
    }

    if (activeElement.closest('product-form') || activeElement.closest('form[action*="/cart/add"]')) {
      return 'pdp';
    }

    return 'unknown';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
